import { connect } from 'react-redux';
import { breakpointSelector } from 'selectors/breakpoint';
import RentalTripCard from './RentalTripCard';

const mapStateToProps = (state) => ({
  breakpoint: breakpointSelector(state),
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RentalTripCard);
